import { Typography } from "@mui/material";

export default function PaginationCount ({rowsPerPage ,page ,count}){
return <Typography className="p-2" variant="h7">
         { (page) * rowsPerPage + (count>0?1:0)} - {Math.min((page+1) * rowsPerPage, count)} of {count}
        </Typography>
}